import {NgModule} from '@angular/core';
import {RouterModule} from "@angular/router";

@NgModule({
    imports: [
        RouterModule,
    ],
    exports: [
        RouterModule
    ]
})
export class SkinAnalyzerRoutingModule { }
